.signet-date-range {
  font-family: Lato;
  font-weight: 400;
  position: relative;
  width: fit-content;

  .input-container {
    display: flex;
    align-items: center;
    gap: 20px;

    .input-clear-button {
      position: absolute;
      top: 25%;
      right: 5%;
      cursor: pointer;
      font-weight: bold;
      color: var(--gray-500);
    }

    .input-label-container {
      position: relative;

      .start-date-input-label {
        position: absolute;
        top: -25%;
        left: 10px;
        padding: 3px;
        font-size: 0.75rem;
        background: transparent;
        color: var(--gray-500);
        transition: all 0.25s ease-in-out;
        pointer-events: none;
        z-index: 99;
        font-weight: 400;

        &:before {
          content: "";
          position: absolute;
          height: 6px;
          bottom: 8px;
          z-index: -1;
          width: 110%;
          display: block;
          left: -2px;
          background: var(--pure-white);
        }
      }
    }

    .input-label-container {
      position: relative;

      .end-date-input-label {
        position: absolute;
        top: -25%;
        left: 10px;
        padding: 3px;
        font-size: 0.75rem;
        background: transparent;
        color: var(--gray-500);
        transition: all 0.25s ease-in-out;
        pointer-events: none;
        z-index: 99;
        font-weight: 400;

        &:before {
          content: "";
          position: absolute;
          height: 6px;
          bottom: 8px;
          z-index: -1;
          width: 110%;
          display: block;
          left: -2px;
          background: var(--pure-white);
        }
      }
    }

    input {
      border: 1px solid var(--gray-500);
      background-color: transparent;
      padding: 12px 16px;
      border-radius: 4px;
      outline: 0;

      &.input-size-small {
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 12px;
        padding-right: 12px;
        font-size: 14px;
        line-height: 20px;
        /* 32px total height with border */
      }

      &.input-size-medium {
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 14px;
        padding-right: 14px;
        font-size: 16px;
        line-height: 20px;
        /* 42px total height with border */
      }

      &.input-size-large {
        padding-top: 15px;
        padding-bottom: 15px;
        padding-left: 16px;
        padding-right: 16px;
        font-size: 18px;
        line-height: 20px;
        /* 52px total height with border */
      }

      &:focus {
        border: 1px solid var(--action-default);
        box-shadow: 0px 0px 3px var(--action-default);
      }

      &.disabled {
        cursor: not-allowed;
        background-color: var(--gray-50) !important;
      }

      &.warning {
        border: 1px solid #ffcc00;
      }

      &.start-date-error {
        border: 1px solid #cc3300;
      }

      &.end-date-error {
        border: 1px solid #cc3300;
      }
    }
  }
}

signet-date-range[size='small'] .input-label-container .start-date-input-label,
signet-date-range[size='sm'] .input-label-container .start-date-input-label,
signet-date-range[size='small'] .input-label-container .end-date-input-label,
signet-date-range[size='sm'] .input-label-container .end-date-input-label {
  top: -36% !important;
}

.calendar-container-wrapper {
  display: flex;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 9999;
  background-color: white;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.3);
  // min-width: 600px;
  border-radius: 6px;
  // padding: 20px;
}

.shortcuts {
  border-right: 1px solid rgb(208, 208, 208);
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: start;

  .shortcut-button {
    white-space: nowrap;
    margin-bottom: 4px;

    font-size: inherit;
    cursor: pointer;
  }
}

.calendar-container-content {
  display: flex;
  align-items: self-start;
  // gap: 30px;
  position: relative;

  .year-selector {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    padding: 20px 20px 10px 20px;
    min-width: 500px;

    .calendar-icon {
      cursor: pointer;
      line-height: 0 !important;
    }
  }

  .year-selector-content {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 30px;
    padding: 0 20px 40px;
    min-width: 500px;

    .year-item {
      cursor: pointer;
      font-size: 14px;

      &:hover {
        color: var(--primary-main);
      }
    }
  }

  .month-selector {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 40px;
    padding: 0px 20px 40px 20px;

    .month-item {
      cursor: pointer;
      font-size: 14px;

      &:hover {
        color: var(--primary-main);
      }
    }
  }

  .calendar {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    padding: 20px;

    .month-year {
      margin-bottom: 20px;

      .month,
      .year {
        cursor: pointer;

        &:hover {
          color: var(--primary-main);
        }
      }
    }

    .weekdays {
      display: grid;
      grid-template-columns: repeat(7, minmax(0, 1fr));
      gap: 0;

      .weekday {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        width: 36px;
        height: 36px;
        color: #717171;
      }
    }

    .days {
      display: grid;
      grid-template-columns: repeat(7, minmax(0, 1fr));
      column-gap: 0;
      row-gap: 2px;

      .day {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 36px;
        width: 36px;
        border-radius: 100%;
        cursor: pointer;
        font-size: 12px;
        margin: 0;
        border: solid 1px transparent;
        position: relative;

        &:not(.selected-day, .blank):after {
          // border: 1px solid var(--gray-400);
          background: transparent;
          border: transparent;
          opacity: 0.2;
          display: block;
          content: "";
          width: 100%;
          height: 100%;
          z-index: -2;
          position: absolute;
          top: 0;
          left: 0;
        }

        &:not(.selected-day, .blank):hover:after {
          border-radius: 100%;
          background: var(--action-default);
          opacity: 0.2;
        }

        &.current-day {
          border: 1px solid var(--gray-400);
          border-radius: 100% !important;
        }

        &.selected-day {
          background-color: var(--action-default);
          color: white;
          border-radius: 50%;
          position: relative;
          border: transparent;

          &::after {
            background: var(--action-default);
            border: transparent;
            border-radius: 50%;
            opacity: 0.2;
            display: block;
            content: "";
            width: 100%;
            height: 100%;
            z-index: -2;
            position: absolute;
            top: 0;
            left: 0;
          }

          &:nth-child(7n + 1).selected-day:after {
            border-top-left-radius: 50%;
            border-top-right-radius: 0;
            border-bottom-left-radius: 50%;
            border-bottom-right-radius: 0;
          }
          &:nth-child(7n).selected-day:after {
            border-top-right-radius: 50%;
            border-top-left-radius: 0;
            border-bottom-right-radius: 50%;
            border-bottom-left-radius: 0;
          }

          &.selected-first-day,
          &.selected-last-day {
            overflow: unset;
          }
          &.selected-first-day:after {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }
          &.selected-last-day:after {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
          &::before {
            content: "";
            display: block;
            border-radius: 50%;
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 1;
          }

          &:hover::before {
            background: var(--action-default);
            opacity: 0.3;
          }
        }

        &.disabled-day {
          background-color: rgba(0, 0, 0, 0.1);
          color: white;
          cursor: not-allowed;
        }

        &.between-day {
          background-color: rgba(var(--action-default), 0.5);
          color: black;
          border-radius: 0;
          &::after {
            border-radius: 0;
          }

          &:hover {
            border-radius: 100%;
          }
        }

        &.blank {
          cursor: default;
          background-color: transparent;

          &:hover {
            border: none;
          }
        }
      }
    }

    .calendar-icon {
      cursor: pointer !important;
      position: absolute;
      top: 20px;

      &.right {
        right: 20px;
      }

      &.left {
        left: 20px;
      }
    }
  }

  .divider {
    height: 100%;
    width: 1px !important;
    background-color: rgb(208, 208, 208);
    position: absolute;
    top: 0;
    left: 50%;
  }
}
